import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'

// Mirrors canAccessSystemMonitorGuard: sidebar-hiding is not access control,
// so this redirects an in-SPA navigation to the announcements admin page away
// when the member lacks the announcements role. `currentUser` is a signal kept
// in sync by DashboardComponent's whoAmI fetch; on a cold load (hard refresh /
// bookmark) it is still null when guards run, so this defers (returns true)
// like the kycRequiredGuard / orgKycGuard pattern. The backend gate remains the
// real boundary in that case; this guard is the in-session UX layer.
export const canAccessBoAnnouncementsGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)
  const user = authService.currentUser()
  if (!user) return true
  if (authService.hasBackofficeModuleRole('announcements', 'maker', 'checker', 'viewer', 'admin')) return true
  return router.createUrlTree(['/trading-hub/dashboard/bo-overview'])
}
